import { Component, HostListener, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LightboxService } from './lightbox.service';
import { IconsComponent } from '@sml/icons';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'sml-lightbox',
  imports: [CommonModule, IconsComponent],
  templateUrl: './lightbox.component.html',
  styleUrl: './lightbox.component.scss',
  animations: [
    trigger('fadeSlide', [
      transition('* => *', [
        style({ opacity: 0, transform: 'translateX(50px)' }), // Start off-screen
        animate('300ms ease-in-out', style({ opacity: 1, transform: 'translateX(0)' })) // Animate to final state
      ])
    ])
  ]
})
export class LightboxComponent {
  images: string[] = [];
  currentIndex = -1;
  public showLightbox = false;
  public showNavigation = true;
  private isDragging = false;
  private startX: number = 0;
  private readonly DRAG_THRESHOLD = 20;


  constructor(private readonly lightboxService: LightboxService, private readonly ngZone: NgZone) {
    this.lightboxService.images$.subscribe(images => {
      this.ngZone.run(() => {
        this.images = images;
      });
    });

    this.lightboxService.currentIndex$.subscribe(index => {
      this.ngZone.run(() => {
      this.currentIndex = index ?? 0;
      });
    });
    this.lightboxService.showLightbox$.subscribe(show => {
      if (show) {
        this.open();
      }
    });
    this.lightboxService.showNavigation$.subscribe(show => {
      this.ngZone.run(() => {
        this.showNavigation = show;
      });
    });
  }

  open() {
    this.showLightbox = true;
  }

  close() {
    this.showLightbox = false;
    this.lightboxService.close();
  }

  next() {
    this.walk=0;
    if(this.currentIndex === this.images.length - 1) return;
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prev() {
    this.walk=0;
    console.log("prev",this.currentIndex);
    if(this.currentIndex === 0) return;
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') {
      this.next();
    } else if (event.key === 'ArrowLeft') {
      this.prev();
    } else if (event.key === 'Escape') {
      this.close();
    }
  }
  
// Implement drag start
onDragStart(event: MouseEvent | TouchEvent ): void {
  this.isDragging = true;
  this.startX =
    'touches' in event
      ? (event as TouchEvent).touches[0].pageX
      : (event as MouseEvent).pageX;

  event.preventDefault();
}
walk = 0;

// Implement drag move
onDragMove(event: MouseEvent | TouchEvent ): void {
  if (!this.isDragging) return;

  const x =
    'touches' in event
      ? (event as TouchEvent).touches[0].pageX
      : (event as MouseEvent).pageX;
  this.walk = x - this.startX; // Calculate drag distance
}

// Implement drag end
onDragEnd(): void {
  if (!this.isDragging) return;
  this.isDragging = false;
console.log("walk",this.walk)
  // ✅ Fix: Only move to next/prev if drag distance is greater than threshold
  if (Math.abs(this.walk) < this.DRAG_THRESHOLD) {
    return; // This was a click, not a drag
  }

  if (this.walk < 0) {
    this.next();
  } else if (this.walk > 0) {
    this.prev();
  }
}

// Ensure dragging stops if the mouse leaves the container
@HostListener('mouseleave') 
onMouseLeave(  ): void {
  this.onDragEnd(); // Trigger the same logic as on drag end
}

// Ensure dragging stops on mouse up
@HostListener('mouseup', ['$event']) 
onMouseUp(  ): void {
  this.onDragEnd(); // Trigger the same logic as on drag end
}

// Ensure dragging stops for touch events
@HostListener('touchend') 
onTouchEnd(  ): void {
  this.onDragEnd(); // Trigger the same logic as on drag end
}

// Optionally add mousemove listener for cleanup when mouse is moved outside of slider container
@HostListener('document:mousemove', ['$event'])
onDocumentMouseMove(event: MouseEvent) {
  if (!this.isDragging) return;
  // Prevent document scroll when dragging
  event.preventDefault();
}
scrollInProgress = false; 



}
